import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const MediaContentContainer = styled.div`
  padding: 22px 16px 8px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    overflow-y: auto;
  }
`

export const ButtonsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 20px;
`
